import {
  trigger,
  state,
  style,
  transition,
  animate,
} from "@angular/animations";
import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from "@angular/core";
import { MapHelperService } from "../../../../../../../../../services/map-helper.service";
import { LayerDTO } from "../../../../models/LayerDTO";
import { filter, Observable, Subscription, take } from "rxjs";
import { LocationCategoryDTO } from "../../../../models/LocationCategoryDTO";
import { PanelInternalLayerService } from "../../../../services/Panel-Internal-Layer.service";
import { MediaMatcher } from "@angular/cdk/layout";
import { ToolCarsSelectorService } from "../../../../../../../pages/maps/services/Tool-Cars-Selector.service";
import { LayerService } from "../../../../services/Layers.service";
import { EnumLayerTypes } from "src/app/features/shared/helpers/enums/EnumLayerTypes";
import { EnumLayerSources } from "src/app/features/shared/helpers/enums/EnumLayerSources";
import { LocationsMapService } from "../../../../services/LocationsMap.service";
import { MAP_BUILD_NAMES, MAP_MODULE_NAMES } from "src/models/common/EnumMapas";
import { LocalStorageService } from "src/app/features/shared/services/LocalStorage.service";
import { environment } from "src/environments/environment";
import { PanelLocationsService } from "src/app/features/map-features/sections/locations-section/services/Panel-Locations.service";
import { AllowedDTO } from "src/app/features/pages/maps/utils/models/allowedDTO";
import { EnumPanelGPSTabTypes } from "src/app/features/map-features/sections/locations-section/enums/EnumPanelGPSTabTypes";
import { MapRestrictionsService } from "src/app/features/pages/maps/services/MapRestrictions.service";
@Component({
  selector: "panel-internal-layers",
  templateUrl: "./panel-internal-layers.component.html",
  styleUrls: ["./panel-internal-layers.component.css"],
  animations: [
    trigger("mostrarLista", [
      state("visible", style({ opacity: 1, height: "*" })),
      state("hidden", style({ opacity: 0, height: "0px", overflow: "hidden", display: "none" })),
      transition("visible <=> hidden", animate("300ms ease-in-out")),
    ]),
    trigger("expandCollapseLayers", [
      state("expanded", style({ opacity: 1, height: "*" })),
      state("collapsed", style({ opacity: 0, height: "0px", overflow: "hidden", display: "none" })),
      transition("expanded <=> collapsed", animate("300ms ease-in-out")),
    ]),
    trigger("searcherPanel", [
      state("open", style({ transform: "translateX(0)", opacity: 1 })),
      state("closed", style({ transform: "translateX(-100%)", opacity: 0 })),
      transition("open <=> closed", animate("300ms ease-in-out")),
    ]),
  ],
})
export class PanelInternalLayersComponent implements OnInit, OnDestroy {
  allowedParts: AllowedDTO;

  EnumPanelGPSTabTypes = EnumPanelGPSTabTypes;

  isInitializingLayers: boolean = false;

  listaCapasVisible: boolean = false;
  hasVirtualCategories: boolean = false;
  hasNonVirtualCategories: boolean = false;
  hasGPSCategories: boolean = true;
  isGPSCategoriesVisible: boolean = false;

  isSearcherPanelOpen: boolean = false;
  selectedSearchLayer: LayerDTO = null;
  searcherTotalResults: string = "Cargando...";

  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;

  //Array con las posibles opcciones.
  //Si se ocupa hacerlo dinámico con los add-ons después, se puede
  $capas = new Array<LayerDTO>();
  suscription_GetListLayers: Subscription;
  suscription_GetLayerDataByNameGeoJSON: Subscription;
  // $capas = [
  //   { label: 'Geocercas', checked: false, capaId: "" } /*"layer-geofencesPolygons" este es el id que trataba de poner para manipularla en el map helper*/
  // ];

  $capasService: Observable<any>;
  subscription_GetGeofenceIndicator: Subscription;
  suscription_GetCategoryListLayers: Subscription;
  subscription_GetCategoryList: Subscription;
  Subscription_GetMapMainSource: Subscription;
  subscription_tabCategoryFiltersSelected: Subscription;
  enumLayerTypes: any = EnumLayerTypes;

  constructor(
    private mapHelper: MapHelperService,
    private locationsMapService: LocationsMapService,
    public panelInternalLayerService: PanelInternalLayerService,
    public layerCatalogService: LayerService,
    public toolCarsSelectorService: ToolCarsSelectorService,
    private media: MediaMatcher,
    changeDetectorRef: ChangeDetectorRef,
    private localStorageService: LocalStorageService,
    private panelLocationsService: PanelLocationsService,
    private mapRestrictionsService: MapRestrictionsService
  ) {
    this.mobileQuery = media.matchMedia("(min-width: 769px)");
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);

    this.$capasService = this.panelInternalLayerService.getLayers();
    this.subscription_GetGeofenceIndicator = this.$capasService.subscribe((data)=>{
      this.$capas = data;
    });
    this.panelInternalLayerService.closeCaregoryFilter();
  }

  ngOnInit(): void {
    this.allowedParts = this.mapRestrictionsService.allowedParts$.value;
    this.Subscription_GetMapMainSource = this.mapHelper.mainSource$.pipe(
      filter(location => location && location.isMainSourceReady && location.isStyleReady),
      take(1)
    ).subscribe(location => {
      if (location && location.isMainSourceReady && location.isStyleReady && !this.isInitializingLayers) {
        if (location.loadedMapName.includes(MAP_BUILD_NAMES.GPS) || location.loadedMapName.includes(MAP_BUILD_NAMES.Unilever)) {
          this.GetListLayers();
        }
      }
    });

    this.subscription_tabCategoryFiltersSelected = this.panelLocationsService.tabCategoryFiltersSelected.pipe(
      filter(t => t != null && t.filters?.length > 0 && t.categoryToBeAffected != null)
    ).subscribe((selected) => {
      const categoryToBeAffected = selected.categoryToBeAffected;
      
      const currentLayer = this.$capas.find(layer => layer.categoryId == categoryToBeAffected.id);
      if(currentLayer == null)
        return;
        
      if(currentLayer == this.selectedSearchLayer)
        this.closeLayerSearcher();
      if(selected.filters.some(f => f.filtersSelected != null && f.filtersSelected.length > 0)){
        this.panelInternalLayerService.setLayerHasBeenFiltered(currentLayer, true);
      }else{
        this.panelInternalLayerService.setLayerHasBeenFiltered(currentLayer, false);
      }
      
    });
  }

  ngOnDestroy(): void {
    if (this.suscription_GetListLayers)
      this.suscription_GetListLayers.unsubscribe();
      if (this.suscription_GetLayerDataByNameGeoJSON)
      this.suscription_GetLayerDataByNameGeoJSON.unsubscribe();
      if (this.suscription_GetCategoryListLayers)
        this.suscription_GetCategoryListLayers.unsubscribe();
      if (this.subscription_GetCategoryList)
        this.subscription_GetCategoryList.unsubscribe();
    if (this.subscription_GetGeofenceIndicator)
      this.subscription_GetGeofenceIndicator.unsubscribe();
    if (this.Subscription_GetMapMainSource)
      this.Subscription_GetMapMainSource.unsubscribe();
  }

  GetListLayers() {
    this.isInitializingLayers = true;
    if (this.suscription_GetListLayers)
      this.suscription_GetListLayers.unsubscribe();
    this.suscription_GetListLayers = this.layerCatalogService.GetListLayers(EnumLayerSources.Internal).subscribe({
      next: (data) => {
        var capas = data.result as LayerDTO[];
        if (capas.length > 0 && this.mobileQuery.matches) {
          this.layerCatalogService.isInternalLayersVisible = false;
        }
        capas.forEach((element) => {
          if(!environment.production) console.log( "******************CAPA************ " + element.name + "_layer ******** icon: " + element.icon );
          this.panelInternalLayerService.createMapLayer(element);
        });
        this.GetCategories();
        this.isInitializingLayers = false;
      },
      error: (error) => {
        // TODO marca para complete despues
        console.error('Error al obtener lista de capas', error);
        this.isInitializingLayers = false;
      }
    });
  }

  GetCategories(){
    var categories = JSON.parse(this.localStorageService.getListaCategorias()) as LocationCategoryDTO[];
    var nonGPSCategories = categories.filter(lc=>{return !lc.itWorksAsGPS && lc.canBeShownInPanel}) as LocationCategoryDTO[];
    var GPSCategories = categories.filter(lc=>{return lc.itWorksAsGPS}) as LocationCategoryDTO[];

    this.hasVirtualCategories = nonGPSCategories.some((category) => category.itWorksAsVirtualLocation && this.allowedParts?.allowedCategories?.includes(category.id?.toString()));
    this.hasNonVirtualCategories = nonGPSCategories.some((category) => !category.itWorksAsVirtualLocation && this.allowedParts?.allowedCategories?.includes(category.id?.toString()));
    
    this.hasGPSCategories = GPSCategories.length > 0;
    this.isGPSCategoriesVisible = this.hasGPSCategories && this.allowedParts?.allowedCategories?.includes('gps');

    nonGPSCategories.forEach((category) => {
      //crea objeto capa de categoria
      var layerDTO = new LayerDTO();
      layerDTO.name = category.shortName;
      layerDTO.icon = category.icon;
      layerDTO.idLayerType = category.itWorksAsCluster ? EnumLayerTypes.ClusterPoints : EnumLayerTypes.Point;
      layerDTO.atributeDisplay = category.DescriptionProperty != null ? category.DescriptionProperty : "_Id";
      layerDTO.categoryId = category.id;
      layerDTO.isVisible = true;
      layerDTO.checked = false;
      layerDTO.isLoading = false;
      layerDTO.itWorksAsVirtualLocation = category.itWorksAsVirtualLocation;
      layerDTO.isFilteredLayer = category.layerFilter_IsFiltered;
      
      
      // crea el layer en el mapa y sus eventos
      this.panelInternalLayerService.createMapLayer(layerDTO);
      this.locationsMapService.CreateCategoryLayerEvents(layerDTO);
      //si la categoria es de tipo default, se activa la capa
      if ( category.isDefaultLoaded)
        this.panelInternalLayerService.ActivateLayer(layerDTO);
    });
    if(!this.layerCatalogService.isExternalLayersVisible && !this.layerCatalogService.isMapLayersVisible)
      this.layerCatalogService.isInternalLayersVisible = true;
  }

  onClickListaCapas() {
    this.layerCatalogService.isExternalLayersVisible = false;
    this.layerCatalogService.isMapLayersVisible = false;
    this.layerCatalogService.isGeneralManagementVisible = false;
    this.toolCarsSelectorService.isCarSelectionToolVisible = false;
    this.layerCatalogService.isInternalLayersVisible = !this.layerCatalogService.isInternalLayersVisible;
  }

  //se acciona al presionar el switch de una capa, capaActivada es el evento seleciconado
  addLayer(layer: LayerDTO) {
    if(layer.checked)
      return;

    this.panelInternalLayerService.onToggleLayer(layer);
    
    if (this.selectedSearchLayer && this.selectedSearchLayer.name === layer.name && !layer.checked) {
      this.closeLayerSearcher();
    }
  }

  activateGPSLayer(gpsType: string) {
    this.panelInternalLayerService.ActivateGPSLayer(gpsType);
  }

  onAddLayerActivos() {
    if(this.panelInternalLayerService.activeLayer.checked)
      return;
    this.panelInternalLayerService.addLayerActivos();
  }

  onRestartLayer(layer: LayerDTO) {
    if (!layer.checked) 
      return;
    this.panelInternalLayerService.DeactivateLayer(layer);
    this.panelInternalLayerService.ActivateLayer(layer);
  }

  onRestartLayerActivos() {
    this.panelInternalLayerService.reloadGPSLayer();
  }

  onRestartLayerFiltros() {
    this.panelInternalLayerService.reloadGPSFilteredLayer();
  }

  ClosePanel() {
    this.layerCatalogService.isInternalLayersVisible = false;
  }

  toggleInternalLayers(){
    this.panelInternalLayerService.isInternalLayersExpanded = !this.panelInternalLayerService.isInternalLayersExpanded;
  }

  toggleVirtualLayers(){
    this.panelInternalLayerService.isVirtualLayersExpanded = !this.panelInternalLayerService.isVirtualLayersExpanded;
  }

  onExpandCollapseStart(event: any) {
    this.panelInternalLayerService.isExpandCollapseAnimating = true;
  }

  onExpandCollapseDone(event: any) {
    this.panelInternalLayerService.isExpandCollapseAnimating = false;
  }

  onClickLayerFilter(layer: LayerDTO){
    const category = JSON.parse(this.localStorageService.getListaCategorias())?.find((cat) => cat.id == layer.categoryId);
    if(category == null)
      return;

    this.panelInternalLayerService.openCategoryFilter(category, layer);
  }

  openLayerSearcher(layer: LayerDTO) {
    if (!layer.checked) {
      return;
    }
    if(this.isSearcherPanelOpen && this.selectedSearchLayer != null && this.selectedSearchLayer.name === layer.name){
      this.closeLayerSearcher();
      return;
    }
    this.searcherTotalResults = "Cargando...";
    this.selectedSearchLayer = layer;
    this.isSearcherPanelOpen = true;
  }

  closeLayerSearcher() {
    this.isSearcherPanelOpen = false;
    this.selectedSearchLayer = null;
    this.searcherTotalResults = "Cargando...";
  }

  updateSearchTotal(total: string) {
    this.searcherTotalResults = total;
  }
}
